import { ARAM_CONFIG, canShopInAram } from '../../domain/map/aramRules.js';
import { SHOP_ZONE_DISC } from '../scene/aramSpawnMeshes.js';

/**
 * FID-MAP-03: shop zone disc radius ↔ canShopInAram smoke hook.
 */
export function attachShopZoneDebugHooks(win) {
  if (!win) return;
  win.__debugShopZone = () => {
    const atPad = {
      team: 'blue',
      isDead: false,
      x: ARAM_CONFIG.spawnPlatforms.blue.x,
      z: ARAM_CONFIG.spawnPlatforms.blue.z
    };
    const midLane = { team: 'blue', isDead: false, x: 0, z: 0 };
    return {
      spawnRadius: ARAM_CONFIG.spawnRadius,
      discOpacity: SHOP_ZONE_DISC.opacity,
      discEmissive: SHOP_ZONE_DISC.emissiveIntensity,
      canShopAtPad: canShopInAram(atPad),
      canShopMidLane: canShopInAram(midLane)
    };
  };
}
